import { useMutation, useQueryClient } from '@tanstack/react-query'

import useAuth from 'hooks/useAuth'
import { dispatch } from 'store'
import { openSnackbar } from 'store/reducers/snackbar'
import axiosServices from 'utils/axios'

export const useUpdatePage = () => {
  const { user } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      pageId,
      title,
      properties
    }: {
      pageId?: number
      title: string
      properties?: Record<string, any>
    }) => {
      return axiosServices.put(`/businesses/${user?.business_id}/pages/${pageId}`, {
        page: {
          title: title,
          ...properties
        }
      })
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['fetch-pages-tree', user?.business_id] })
      queryClient.invalidateQueries({
        queryKey: ['fetch-page', user?.business_id, variables.pageId]
      })
    },
    onError: (error, variables) => {
      dispatch(
        openSnackbar({
          open: true,
          message: 'Error Updating Page',
          variant: 'alert',
          alert: { color: 'error' },
          close: false
        })
      )
    }
  })
}
